import React from "react";
import { Helmet } from "react-helmet";
import Navbar from '../components/navbar';
import TopBanner from '../components/top-banner';
import Footer from '../components/footer';
import Packages from "../components/packages";
import SocialMediaFixed from "../components/socialmedia-fixed";


const PackagesPage = () => {

    return (
        <>
            <Helmet>
                <title>MP Holidays Tour Packages - Explore Madhya Pradesh with Customized Trips</title>
                <meta name="description" content="Discover the best Madhya Pradesh tour packages with MP Holidays. Choose from heritage, wildlife, pilgrimage, and adventure tours designed for an unforgettable travel experience." />
                <meta name="keywords" content="MP tour packages, Madhya Pradesh holiday packages, heritage tours MP, wildlife tours MP, pilgrimage tours MP, adventure trips Madhya Pradesh, best travel packages MP, customized MP tours" />
                <link rel="canonical" href="https://mpholidays.online/packages" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "OfferCatalog",
                        "name": "MP Holidays Tour Packages",
                        "url": "https://mpholidays.online/packages",
                        "description": "Explore customized tour packages for Madhya Pradesh, including heritage, wildlife, pilgrimage, and adventure trips.",
                        "provider": {
                            "@type": "Organization",
                            "name": "MP Holidays",
                            "url": "https://mpholidays.online"
                        }
                    })}
                </script>
            </Helmet>


            <TopBanner />
            <Navbar />
            <Packages />
            <Footer />
            <SocialMediaFixed />
        </>
    );
};

export default PackagesPage;
